<template>
  <div class="comp-main">
    <div v-if="title">{{ title }}</div>
    <div class="header-input">
      <!-- 输入框-自动完成 -->
      <el-autocomplete
        v-if="type === 'input'"
        ref="refAutocomplete"
        style="width: 100%"
        size="mini"
        :debounce="500"
        v-model="keyword"
        :fetch-suggestions="inputFilter"
        popper-class="popper-width-auto"
        clearable
        @focus="inputFocus"
        @input="inputFocus"
        @clear="inputClear"
        @keyup.enter.native="inputEnter"
        @select="inputChange"
      >
        <template slot-scope="{ item }">
          <div :title="item.value">{{ item.value }}</div>
        </template>
      </el-autocomplete>

      <!-- 下拉选择 -->
      <el-select
        v-if="type === 'select'"
        v-model="selfSelectActive"
        style="width: 100%"
        size="mini"
        collapse-tags
        multiple
        clearable
      >
        <el-option
          v-for="(item, index) in list"
          class="flex flex-x-between"
          :key="index"
          :label="item.val"
          :value="item.val"
        >
          <span class="m-r-10">{{ item.val }}</span>
          <span>{{ item.key }}</span>
        </el-option>
      </el-select>

      <!-- 日期范围选择 -->
      <e-date-picker
        v-if="type === 'daterange'"
        :value.sync="selfDatePicker"
        @change="datePickerChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 类型
    type: {
      type: String,
      default: 'input'
    },
    // 标题
    title: {
      type: String,
      default: ''
    },
    // 字段
    field: {
      type: String,
      required: true
    },
    // 接口地址
    url: {
      type: String,
      default: ''
    },
    // date默认值
    value: {
      type: [String, Array],
      default: () => {
        return ''
      }
    },
    // 下拉列表
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    filterData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      keyword: '',
      selfFilterData: {
        is_delete: false // 不显示已删除的数据
      },
      formData: {},
      inputList: [],
      selfSelectActive: []
    }
  },
  computed: {
    selfDatePicker: {
      get() {
        return this.value
      },
      set(val = ['', '']) {
        this.updateValue(val)
      }
    }
  },
  watch: {
    selfSelectActive: {
      handler(val) {
        this.updateValue(val)
      },
      deep: true
    },
    filterData: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.selfFilterData)) {
          this.selfFilterData = this.$util.deepCopy(val)
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    if (this.value) this.keyword = this.value
  },
  methods: {
    // 输入框-筛选关键字
    inputFilter(keyword, callback) {
      let result = this.$util.deepCopy(this.inputList)
      if (keyword) {
        result = result.filter((item) => {
          let str1 = item.value.toLowerCase()
          let str2 = keyword.toLowerCase()
          return str1.includes(str2)
        })
      }
      callback(result) // 调用 callback 返回建议列表的数据
    },
    // 输入框-聚焦
    inputFocus() {
      if (!this.url) return
      let filterData = { ...this.selfFilterData, is_delete: false }
      filterData[this.field] = this.keyword
      filterData = this.$util.searchFilterEmpty(filterData)
      this.$api({
        method: 'post',
        url: this.url,
        data: {
          heardAutoCompleteName: this.field,
          filterData
          // pickerDate: this.pickerDate,
          // formData: this.formData,
          // checkedGridClassIds: null
        }
      }).then((res) => {
        if (res.status === 200) {
          this.$nextTick(() => {
            this.inputList = []
            let resList = (res.data.list || res.data.page.list).filter((item) => item.value !== '')
            let result = resList.map((item) => {
              return {
                value: String(item.value)
              }
            })
            this.inputList = result
            // this.$refs.refAutocomplete.focus()
          })
        }
      })
    },
    // 输入框-清空
    inputClear() {
      this.$refs.refAutocomplete.$children[0].blur()
      this.inputChange()
      setTimeout(() => {
        this.$refs.refAutocomplete.focus()
      }, 100)
    },
    // 输入框-回车
    inputEnter() {
      this.inputChange({ value: this.keyword })
    },
    // 输入框-更新
    inputChange(item) {
      this.$emit('change', { field: this.field, value: item ? item.value : '' })
    },
    // 日期范围-更新
    datePickerChange() {
      this.$emit('change', { field: this.field, value: this.$util.deepCopy(this.value) || [] })
    },
    updateValue(val) {
      let result = this.$util.deepCopy(val)
      this.$emit('update:value', result)
    }
  }
}
</script>

<style lang="less" scoped>
.comp-main {
  color: @colorGrayDeep;
  .header-input {
    margin-top: 2px;
    /deep/ .el-input__inner {
      font-size: 11px;
      height: 24px;
      color: @colorGrayDeep;
      width: 100% !important;
      overflow: hidden;
      padding: 0 2px;
      text-align: center;
    }
    /deep/ .el-date-editor {
      &.el-input__inner {
        padding: 3px 10px;
      }
      .el-range__icon {
        width: 18px;
        color: @colorBlue;
        line-height: 18px;
        margin-left: -5px;
      }
    }
    /deep/ .el-input__icon {
      width: auto;
      line-height: 24px;
    }
    /deep/ .el-input__suffix-inner {
      background: #fff;
    }
    /deep/ .el-select__tags {
      font-weight: normal;
      .el-tag--info ~ .el-tag--info {
        display: none;
      }
    }
  }
}
</style>
